<template>
  <div>
    <div id="myAssetNew">
      <div class="Box">
        <div class="backButton" @click="goback"><i class="el-icon-back"></i></div>
  
        <div class="typeBtns">
          <div
            v-for="(item, index) in typeList"
            :key="index"
            class="typBtn"
            :class="currentTab == index ? 'activeBl' : ''"
            @click="changeTab(item, index)"
          >
            {{ item.name }}
          </div>
        </div>
  
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
/*global http protocolTrans BaseApi protocol */
// import noSign from '../myAssetNew/tab/noSign.vue'
export default {
  name: 'MyAssetNew',
  components: {
    // noSign
  },
  data() {
    return {
      reLoad: false,
      sign: localStorage.getItem('signTea'),
      open: localStorage.getItem('openTea'),
      activeIndex: '8',
      isShowThz: window.g.ISSHOWTHZ,
      typeList: [
        {
          name: '我的余额',
          path: '/myAssetNew/myBalance'
        },
        {
          name: '我的提货值',
          path: '/myAssetNew/myTeaBalance'
        }
      ],
      currentTab: 0
    }
  },
  mounted() {
    if (window.location.hash !== '#/myAssetNew/myBalance') {
      window.location.hash = '#/myAssetNew/myBalance'
    }
    this.searchFirmId1()
  },
  destroyed() {
    localStorage.setItem('isActive111', '')
  },
  methods: {
    goback() {
      this.$router.go(-1)
    },
    changeTab(item, index) {
      this.currentTab = index
      this.$router.push(item.path)
    },
    sxClick() {
      if (localStorage.getItem('isActive111')) {
        this.activeIndex = localStorage.getItem('isActive111')
      }
      this.searchFirmId1()
      this.getIdentificationStatus()
    },
    findBankAccountTea() {
      http.postFront(protocol.param_findBankAccountTea).then((response) => {
        var { value, code, message } = response.data
        if (Number(code) === 0) {
          if (value !== null && JSON.stringify(value) !== '{}' && value !== '0') {
            if (value.signFlag == 1) {
              this.sign = 1
              localStorage.setItem('signTea', '1')
            } else {
              this.sign = 0
              localStorage.setItem('signTea', '0')
            }
          } else {
            this.sign = 0
            localStorage.setItem('signTea', '0')
          }
        } else {
          this.$message(message)
        }
      })
    },
    // 查询认证信息
    getIdentificationStatus() {
      BaseApi.findBaseUserAuditByUserId().then((response) => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value !== null && JSON.stringify(value) !== '{}' && value !== '0') {
            // 已认证
            if (value.auditStatus === 1) {
              this.open = 1
              localStorage.setItem('openTea', '1')
            } else {
              // 未认证
              this.open = 0
              localStorage.setItem('openTea', '0')
            }
          } else {
            this.open = 0
            localStorage.setItem('openTea', '0')
          }
        } else {
          this.$message(message)
        }
      })
    },
    handleSelect(key) {
      localStorage.setItem('isActive111', key)
    },
    searchFirmId1() {
      const userMes = this.$store.state.common.sessionInfo
      protocolTrans.param_firmIdSearch.param.userId = userMes.userId
      http.postFront(protocolTrans.param_firmIdSearch).then((response) => {
        var { value, code, message } = response.data
        if (Number(code) === 0) {
          localStorage.setItem('FirmIdList_w', JSON.stringify(value))
        } else {
          this.$message(message)
        }
      })
    },
    goNext() {
      this.$refs.aggreementDialog.showDialog()
    }
  }
}
</script>
<style scoped lang="scss">
#myAssetNew{
  height: calc(100vh - 40px);
  overflow-y: auto;
  overflow-x: hidden;
}
.Box {
  // min-height: calc(100vh - 45px);
  margin: 34px auto;
  width: 1200px;
  .backButton {
    cursor: pointer;
    position: fixed;
    left: 50px;
    top: 70px;
    width: 40px;
    height: 40px;
    background: #000000;
    border-radius: 2px 2px 2px 2px;
    opacity: 0.5;

    color: #fff;
    font-size: 20px;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .typeBtns {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 24px;
    .typBtn {
      height: 25px;
      font-family: PingFang TC, PingFang TC;
      font-weight: 400;
      font-size: 20px;
      color: #666666;
      text-align: left;
      font-style: normal;
      text-transform: none;

      cursor: pointer;
    }
    .activeBl {
      color: #333333;
      position: relative;
    }
    .activeBl::after {
      position: absolute;
      content: '';
      height: 2px;
      bottom: -5px;
      left: 30px;
      right: 30px;
      background: #333333;
    }
  }
}
.ljsxBtn {
  cursor: pointer;
  width: 334px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #0486fe;
  border-radius: 4px 4px 4px 4px;
  margin-left: calc(50% - 167px);
  margin-top: 35px;
  margin-bottom: 35px;
  font-size: 20px;
  font-family: PingFang HK-Medium, PingFang HK;
  font-weight: 500;
  color: #ffffff;
}

</style>
